import * as HttpService from './HttpService'

let namespace = 'swops'

let active = (params, cb, errorCb) => {
    HttpService.get('active-swops', params, cb, errorCb)
}

let all = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let find = (id, params, cb, errorCb) => {
    HttpService.get(namespace + '/' + id, params, cb, errorCb)
}

let addPart = (swopId, partId, params, cb, errorCb) => {
    HttpService.post(namespace + '/' + swopId + '/parts/' + partId, params, cb, errorCb)
}

let removePart = (swopId, partId, params, cb, errorCb) => {
    HttpService.post(namespace + '/' + swopId + '/parts/' + partId + '/remove', params, cb, errorCb)
}

let test = (swopId, params, cb, errorCb) => {
    HttpService.post('swop-test/' + swopId, params, cb, errorCb)
}

export {
    active,
    all,
    find,
    addPart,
    removePart,
    test
}



// WEBPACK FOOTER //
// ./src/services/swopService.js